export const state = () => ({
    addedServices: [],
    groups: [],
    exchangeRates: {},
    currentCurrency: "EUR",
})